import type { PropType } from 'vue';
import type { TWarningProps } from './TWarning.types';
import { merge } from 'es-toolkit/compat';
import { computed, defineComponent } from 'vue';
import { TIcon } from '../TIcon';
import { TTypography } from '../TTypography';
import { useStyles } from './TWarning.styles';

const defaultProps = {
  variant: 'default',
};

export const TWarning = defineComponent({
  name: 'TWarning',
  props: {
    fullWidth: Boolean as PropType<TWarningProps['fullWidth']>,
    icon: String as PropType<TWarningProps['icon']>,
    variant: String as PropType<TWarningProps['variant']>,
  },
  setup(_props, { slots }) {
    const props = computed(() => merge({}, defaultProps, _props));

    const baseClass = useStyles();
    const classes = computed(() => [
      baseClass.value,
      `${baseClass.value}--${props.value.variant}`,
      {
        [`${baseClass.value}--full-width`]: props.value.fullWidth,
      },
    ]);

    const colorMap = {
      default: 'gray.medium1',
      success: 'success',
      'in-process': 'inProcessDark',
      warning: 'warning',
      error: 'error',
      info: 'info',
    };
    const iconColor = computed(() => colorMap[props.value.variant]);

    return () => (
      <div class={classes.value} role="alert">
        {props.value.icon && (
          <TIcon
            icon={props.value.icon}
            class={`${baseClass.value}__icon`}
            color={iconColor.value}
          />
        )}
        {' '}
        {
          slots.content?.()
            ? slots.content?.()
            : (
                <TTypography variant="b3" class={`${baseClass.value}__text`}>
                  {slots.default?.()}
                </TTypography>
              )
        }
      </div>
    );
  },
});
